import { BRIGHTCOVE } from '../../../constants/constants';
import BrightcoveVideo from '../../shared/brightcove/';
import Overlay from './overlay';
import PropTypes from 'prop-types';
import React from 'react';

const CustomVideo = ({heroOptions, region}) => {
  const hasHeroMessage = heroOptions.showHeroMessage && heroOptions.heroMessage;
  return (
    <div className="hero-slider">
      <div className={`video-wrapper ${hasHeroMessage ? 'ada-overlay' : ''}`}>
        <div className="embed-responsive embed-responsive-16by9 hero-background-video">
          <BrightcoveVideo title={'Agent Video'} bcVideoRefId={heroOptions.video.bcVideoRefId} playerId={BRIGHTCOVE.BACKGROUND_PLAYER} autoplay={true}/>
        </div>
      </div>
      <Overlay heroOptions={heroOptions || {}} region={region.urlPart}/>
    </div>
  );
};

CustomVideo.propTypes = {
  heroOptions: PropTypes.object.isRequired,
  region: PropTypes.object.isRequired,
};

export default CustomVideo;


// WEBPACK FOOTER //
// ./src/components/homepage/hero-slider/custom-video.js